module.exports = __webpack_public_path__ + "img/banner-1.fb4ed3cd.jpg";